import React, { useEffect, useState } from "react";
import {
  CloseCircleOutlined,
  PlusCircleFilled,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  Layout,
  message,
  Row,
  Table,
  Tooltip,
} from "antd";
import useRetailers from "../../hooks/useRetailers";
import RetailersForm from "./RetailersForm";
import search from "../../helpers/search";
import { retailerService } from "../../services/RetailerService";
import { retailer_default } from "./types";
import { useForm } from "antd/lib/form/Form";

const { Header, Content } = Layout;

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
];

const RetailersPage: React.FC = function () {
  const [form] = useForm();
  const [searching, setSearching] = useState(false);
  const [visible, setVisible] = useState(false);
  const [state, setState] = useState({
    visible: false,
    selected: retailer_default,
    isCreate: false,
    data: [],
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    pagination_search: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
  });
  const [usersToDisplay, setUsersToDisplay] = useState([]);

  const onSearch = async (key: string) => {
    const { searchWord } = form.getFieldsValue();
    if (!searchWord) {
      message.error("Please enter a valid search string!");
      return;
    }

    setSearching(true);
    const searchData = [
      {
        key,
        value: encodeURIComponent(searchWord),
        collection: "retailers",
      },
    ];

    const searchedData = await search(searchData, retailerService, key);
    setUsersToDisplay(searchedData.data);
    setState({
      ...state,
      pagination_search: {
        ...state.pagination_search,
        total: searchedData.total,
        current: 1,
      },
    });
    setSearching(false);
  };

  const [retailers, loadingRetailers] = useRetailers(state.pagination.current);

  const onClose = async () => {
    const { searchWord } = form.getFieldsValue();
    setState({
      ...state,
    });
    setSearching(true);
    if (searchWord) {
      const searchData = [
        {
          key: "name",
          value: encodeURIComponent(searchWord),
          collection: "retailers",
        },
      ];

      const searchedData = await search(searchData, retailerService, "name");
      setUsersToDisplay(searchedData.data);
    } else {
      const searchedData = await retailerService.getAll(
        state.pagination.current
      );
      const data_brandsToDisplay = searchedData.data.retailers.length
        ? searchedData.data.retailers
        : retailers;
      setUsersToDisplay(data_brandsToDisplay);
    }

    setSearching(false);
  };

  const handleTableChange = async (pagination: any) => {
    setSearching(true);
    setState({
      ...state,
      data: [],
      pagination: pagination,
    });
    const data = await retailerService.getAll(pagination.current);
    setUsersToDisplay(data.data.retailers);
    setSearching(false);
  };

  const handleTableSearchChange = async (pagination: any) => {
    const { searchWord } = await form.getFieldsValue();
    setSearching(true);
    setState({
      ...state,
      data: [],
      pagination_search: pagination,
    });
    const searchData = [
      {
        key: "name",
        value: encodeURIComponent(searchWord),
        page: pagination.current,
        collection: "retailers",
      },
    ];

    const data = await search(searchData, retailerService, "name");
    setUsersToDisplay(data.data);
    setSearching(false);
  };

  useEffect(() => {
    setUsersToDisplay(retailers.retailers);
    setState({
      ...state,
      pagination: {
        ...state.pagination,
        total: retailers.total,
      },
    });
  }, [retailers]);

  const loading = searching || loadingRetailers;

  return (
    <Layout style={{ padding: 20 }}>
      <Header
        style={{
          textAlign: "left",
          backgroundColor: "#F0F2F5",
          padding: 0,
          borderRadius: 15,
        }}
      >
        <Row>
          <Col span={12}>
            <h3 style={{ fontWeight: "bold", paddingLeft: 0 }}>
              Retailers (
              <span style={{ color: "#0a1e96" }}>
                {retailers && retailers.total ? retailers.total : 0}
              </span>
              )
            </h3>
          </Col>
          <Col span={12} style={{ textAlign: "right", paddingRight: 0 }}>
            <Button
              onClick={() => {
                setVisible(true);
                setState({
                  ...state,
                  isCreate: true,
                  selected: retailer_default,
                });
              }}
              type="primary"
              shape="round"
              icon={<PlusCircleFilled />}
              style={{ width: 150 }}
            >
              Add New
            </Button>
          </Col>
        </Row>
      </Header>
      <Content>
        <Row
          style={{
            textAlign: "left",
            backgroundColor: "white",
            padding: 20,
            borderRadius: 10,
            marginTop: 0,
          }}
        >
          <Col span={24}>
            <Row>
              <Col span={24} style={{ fontWeight: "bold" }}>
                What are you looking for?
              </Col>
            </Row>
            <Row style={{ marginTop: 20 }}>
              <Form
                form={form}
                initialValues={{ searchWord: "" }}
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  flexWrap: "wrap",
                }}
                onValuesChange={(changedVals) => {
                  if (changedVals.searchWord === "") {
                    onClose();
                  }
                }}
              >
                <Col>
                  <Form.Item name="searchWord">
                    <Input
                      style={{ width: 300, borderRadius: 10 }}
                      prefix={<SearchOutlined style={{ color: "#ccc" }} />}
                      placeholder={"Search"}
                      suffix={
                        <Tooltip title="Clear Search">
                          <CloseCircleOutlined
                            onClick={() => {
                              setUsersToDisplay(retailers.retailers);
                              setState({
                                ...state,
                                pagination: {
                                  current: 1,
                                  pageSize: 10,
                                  total: retailers.total,
                                },
                              });
                              form.setFieldsValue({
                                searchWord: ""
                              })
                            }}
                            style={{
                              color: "rgba(0,0,0,.45)",
                            }}
                          />
                        </Tooltip>
                      }
                    ></Input>
                  </Form.Item>

                </Col>
                <Col style={{ textAlign: "right", paddingRight: 0 }}>
                  <Form.Item>
                    <Button
                      type="primary"
                      shape="round"
                      htmlType="submit"
                      onClick={() => onSearch("name")}
                      style={{ width: 150 }}
                    >
                      Search By Name
                    </Button>
                  </Form.Item>

                </Col>
              </Form>

            </Row>
          </Col>
        </Row>

        <Row
          style={{
            padding: 20,
            backgroundColor: "white",
            marginTop: 20,
            borderRadius: 15,
          }}
        >
          <Col span={24}>
            {!form.getFieldValue("searchWord") ? (
              <Table
                pagination={state.pagination}
                loading={loading}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => {
                      setState({
                        ...state,
                        selected: record,
                        isCreate: false,
                      });
                      setVisible(true);
                    },
                  };
                }}
                dataSource={usersToDisplay}
                columns={columns}
                onChange={handleTableChange}
              />
            ) : (
              <Table
                pagination={state.pagination_search}
                loading={loading}
                onRow={(record, _) => {
                  return {
                    onClick: () => {
                      setState({
                        ...state,
                        isCreate: false,
                        selected: record,
                      });
                      setVisible(true);
                    },
                  };
                }}
                dataSource={usersToDisplay}
                columns={columns}
                onChange={handleTableSearchChange}
              />
            )}
          </Col>
        </Row>
      </Content>
        <RetailersForm
          visible={visible}
          values={
            state.isCreate
              ? { ...retailer_default }
              : {
                ...state.selected,
              }
          }
          isChanged={false}
          setVisible={setVisible}
          isCreate={state.isCreate}
          onClose={onClose}
        />
    </Layout>
  );
};

export default RetailersPage;
